import _ from "lodash";
const moment = require('moment-timezone');
const CET_TZ = 'Europe/Paris';

export class RaceHandler {
  constructor(debug_mode, debug_data) {
    this.meeting_list = [];
    this.race_info = [];
    this.current_race = null;
    this.next_race = null;
    this.debug_mode = debug_mode;
    this.debug_data = debug_data;
    this.finish = [];
    this.race_end = false;
  }

  get_moment_in_cet_tz() {
    return moment().tz(CET_TZ);
  }

  // set_meeting_list -------------------
  set_meeting_list(a) {
    // sort meetings by heurec
    let a_sorted = _.orderBy(
      a, 
      [function(record) { return Number(record.heurec.replace(':', ''))}], 
      ['asc']
    );
    this.meeting_list = a_sorted;
  }

  // set_race_info ----------------------
  set_race_info(a) {
    this.race_info = a;
  }

  // merge_race_info --------------------
  merge_race_info(a) {
    for (let i=0; i < a.length; i++) {
      for (let j=0; j<this.race_info.length; j++) {
        if (a[i].NumP === Number(this.race_info[j].num)) {
          a[i].nomc = `${this.race_info[j].nomc} (${this.race_info[j].jock})`;
        }
      }
    }
    return a;
  }

  // search_race ------------------------
  search_race() {
    let h_curr = (this.debug_mode) ? this.debug_data.time[0] : this.get_moment_in_cet_tz().hour();
    let m_curr = (this.debug_mode) ? this.debug_data.time[1] : this.get_moment_in_cet_tz().minute();
    let c = moment(h_curr +':'+ m_curr, 'HH:mm');
    let found = false;

    for (let i=0; i < this.meeting_list.length; i++) {
      let race = this.meeting_list[i];
      if (this.debug_mode && 
          Number(race.numr) === Number(this.debug_data.race_r) && 
          Number(race.numc) === Number(this.debug_data.race_c)
        )
      {
        found = true;
        this.current_race = race;
        this.current_race.prefix = `REPLAY ${race.date}`;
        if (this.meeting_list[i+1]) {
          this.next_race = this.meeting_list[i+1];
        }
        return this.current_race;
      }      
      else if (!found) 
      { 
        let r = moment(race.heurec, 'HH:mm');
        let diff = moment.duration(r.diff(c)).asMinutes();
        // search for ongoing race
        if ((diff < 20) && (diff > -20) && (r <= c)) {
          found = true;
          this.current_race = race;
          this.current_race.prefix = `CURRENT`;
          if (this.meeting_list[i+1]) {
            this.next_race = this.meeting_list[i+1];
          }
          return this.current_race;
        }
        // search for next race
        else if (!found && (diff > -20) && (r >= c)) 
        {
          found = true;
          this.current_race = race;
          this.current_race.prefix = `NEXT RACE`;
          if (this.meeting_list[i+1]) {
            this.next_race = this.meeting_list[i+1];
          }
          return this.current_race;
        }
      }
    }
  }

  // get_next_race ----------------------
  get_next_race() {
    return this.next_race;
  }

  // get_current_race -------------------
  get_current_race() {
    return this.current_race;
  }

  // is_new_race ------------------------
  is_new_race(r, c) {
    if (Number(this.current_race?.numr) !== Number(r) ||  Number(this.current_race?.numc) !== Number(c) ) {
      console.log('NEW RACE !!!!!! ', `R${this.current_race?.numr}C${this.current_race?.numc} --> R${r}C${c}`);
      this.current_race = null;
      this.next_race = null;
      this.race_end = false;
      this.finish = [];
      for (let i in this.meeting_list) {
        let race = this.meeting_list[i];
        if (Number(race.numr) === Number(r) && Number(race.numc) === Number(c)) {
          this.current_race = race;
          this.current_race.prefix = `CURRENT`;
          if (this.meeting_list[i+1]) {
            this.next_race = this.meeting_list[i+1];
          }
        }
      }
      return true;
    }
    return false;
  }

  // add_finish -------------------------
  add_finish(a_sec) {
    this.race_end = true;
    let found = false;
    for (let i in a_sec) {
      for (let f in this.finish) {
        if (this.finish[f].PosC === a_sec[i].PosC) {
          found = true;          
        }
      }
      if (!found) {
        this.finish.push(a_sec[i]);
      }
      found = false;
    }
    return this.finish;
  }

}